import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, Typography, Button } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useSetAtom, useAtomValue } from 'jotai';
import capitalize from '../../Helpers/StringsFormatting/capitalize';
import {
  selectedCustomerIdAtom,
  additionalCustomerDataAtom,
  selectedLeadIdAtom,
} from '../../Atoms';
import { APP_ROUTES } from '../../Router/routes';

const SectionBreadcrumbs = function SectionBreadcrumbs() {
  const intl = useIntl();
  const location = useLocation().pathname;

  const currentSection = Object.keys(APP_ROUTES).find(
    (route) => APP_ROUTES[route] === location
  );

  const setSelectedLeadId = useSetAtom(selectedLeadIdAtom);
  const setSelectedCustomerId = useSetAtom(selectedCustomerIdAtom);
  const additionalCustomerData = useAtomValue(additionalCustomerDataAtom);

  const closeCustomerDetails = () => {
    setSelectedCustomerId('');
    setSelectedLeadId('');
    sessionStorage.setItem('currentSection', currentSection); //when returns to customers list reset the currentSection
  };

  return (
    <Breadcrumbs
      id="section-breadcrumbs"
      aria-label="current section and customer Breadcrumbs"
      sx={
        {
          // flexGrow: 1,
        }
      }
    >
      <Button
        id="returnToCustomerList-btn"
        variant="text"
        sx={{
          whiteSpace: 'nowrap',
          textTransform: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
        onClick={closeCustomerDetails}
        color="inherit"
        size="small"
        startIcon={<ArrowBackRoundedIcon />}
      >
        {typeof intl.messages[currentSection] !== 'undefined'
          ? intl.messages[currentSection]
          : intl.messages.UNAVAILABLE}
      </Button>
      <Typography variant="subtitle2" noWrap sx={{
        color: "primary.main"
      }}>
        {capitalize(additionalCustomerData?.customerName)}
      </Typography>
    </Breadcrumbs>
  );
};

SectionBreadcrumbs.propTypes = {
  paddingLeft: PropTypes.number,
};
export default SectionBreadcrumbs;
